export default "__VITE_ASSET__0vQi0MdN__"